import { CircleCheck, CircleX } from "lucide-react";
import { applyAuth0Theme } from "@/utils/theme";
import { useMfaEnrollResultManager } from "./hooks/useMfaEnrollResultManager";
import { AuthLayout } from "@/components/auth/AuthLayout";

function MfaEnrollResult() {
    const { MfaEnrollResult, texts, data, locales } = useMfaEnrollResultManager();
    applyAuth0Theme(MfaEnrollResult);

    const getTitle = () => {
        switch (data?.status) {
            case "success": return texts?.enrolledTitle || locales.header.title.enrolledText;
            case "already-enrolled": return texts?.alreadyEnrolledTitle || locales.header.title.alreadyEnrolledText;
            case "already-used": return texts?.alreadyUsedTitle || locales.header.title.alreadyUsedText;
            case "invalid-ticket": return texts?.invalidTicketTitle || locales.header.title.invalidTicketText;
            case "expired-ticket": return texts?.expiredTicketTitle || locales.header.title.expiredTicketText;
            default: return texts?.genericError || locales.header.title.genericErrorText;
        }
    };

    const getDescription = () => {
        switch (data?.status) {
            case "success": return texts?.enrolledDescription || locales.header.description.enrolledText;
            case "already-enrolled": return texts?.alreadyEnrolledDescription || locales.header.description.alreadyEnrolledText;
            case "already-used": return texts?.alreadyUsedDescription || locales.header.description.alreadyUsedText;
            case "invalid-ticket": return texts?.invalidTicketDescription || locales.header.description.invalidTicketText;
            case "expired-ticket": return texts?.expiredTicketDescription || locales.header.description.expiredTicketText;
            default: return "";
        }
    };

    const isSuccess = data?.status === "success";
    const iconColorClass = isSuccess ? "text-(--ul-theme-color-success)" : "text-(--ul-theme-color-error)";

    return (
        <AuthLayout title={texts?.pageTitle || locales.pageTitle}>
            <div className="auth-view text-center">
                <div className={`flex justify-center mb-6 mt-4 ${iconColorClass}`}>
                    {isSuccess ? (
                        <CircleCheck size={80} strokeWidth={1} />
                    ) : (
                        <CircleX size={80} strokeWidth={1} />
                    )}
                </div>
                <h2 className="auth-page-title mb-2">{getTitle()}</h2>
                <p className="auth-code-prompt">{getDescription()}</p>
            </div>
        </AuthLayout>
    );
}

export default MfaEnrollResult;
